import * as R from 'ramda'
import {
    SAVE_RANGY_SUCCESS
} from '../actionTypes'

const InitialState = null;

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case SAVE_RANGY_SUCCESS:
            return payload

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/rangy.js